export default {"src":"/_next/static/media/projectIcon.ee902be5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};